import { SNAP_GENERATED_PART_ID_PREFIX } from '@lib/consts';
import { OriginalSource } from '@prisma/client';
import { QuoteFormLine } from '@ui/pages/QuoteBuilder/QuoteBuilder';

export type LineItem = Pick<
  QuoteFormLine,
  'partId' | 'customerPartId' | 'finishedPartId' | 'partOriginalSource'
>;

export function useLineItemPartId(lineItem: LineItem, siteCode: string) {
  return selectPartIdForSite(lineItem, siteCode);
}

type LineItemPartIdMap = Record<string, (lineItem: LineItem) => string | null>;

const LINE_ITEM_PART_ID_MAP: LineItemPartIdMap = {
  raf: (i) => i.finishedPartId,
  adf: (i) => {
    if (isSnapPartWithSnapGeneratedId(i)) {
      return i.customerPartId ?? null;
    }

    return i.partId ?? null;
  },
  usa: (i) => {
    if (isSnapPartWithSnapGeneratedId(i)) {
      return null;
    }

    return i.partId ?? null;
  },
};

export function selectPartIdForSite(lineItem: LineItem, siteCode: string) {
  const finderFn = LINE_ITEM_PART_ID_MAP[siteCode.toLowerCase()];

  if (finderFn) {
    return finderFn(lineItem);
  }

  return lineItem.partId;
}

/**
 * Some parts created in SNAP have "Visual-like" IDs, and some don't (they have
 * purely generated IDs that look like `snap-3iu4fh3iuwh43oihu`).
 */
function isSnapPartWithSnapGeneratedId(lineItem: LineItem) {
  return (
    lineItem.partOriginalSource === OriginalSource.SNAP &&
    lineItem.partId.startsWith(SNAP_GENERATED_PART_ID_PREFIX)
  );
}
